import type { ReactNode } from 'react';
import { Dialog } from '@elladx/design-system';
interface ModalProps {
    isOpen: boolean;
    onClose: () => void;
    title: string;
    children: ReactNode;
    dismissible?: boolean;
}
function Modal({ isOpen, onClose, title, children, dismissible = true }: ModalProps) {
    return <Dialog open={isOpen} onClose={onClose} title={title} dismissible={dismissible}>{children}</Dialog>;
}
export default Modal;
